var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      staticStyle: { width: "100%" },
      attrs: {
        border: "",
        stripe: "",
        lazy: "",
        "row-key": "id",
        data: _vm.projects,
        load: _vm.tableLoad
      }
    },
    [
      _c("el-table-column", { attrs: { prop: "id", label: "ID" } }),
      _vm._v(" "),
      _c("el-table-column", { attrs: { prop: "name", label: "名字" } }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "description", label: "description" }
      }),
      _vm._v(" "),
      _c("el-table-column", { attrs: { prop: "timeFrom", label: "timeFrom" } }),
      _vm._v(" "),
      _c("el-table-column", { attrs: { prop: "timeTo", label: "timeTo" } }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { label: "子项目个数" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return _c("ProjectChildrenCount", {
                attrs: { parentId: scope.row.id }
              })
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { label: "工单数量" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return _c("ProjectTicketCount", {
                attrs: { projectId: scope.row.id }
              })
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { label: "createdAt", prop: "createdAt" }
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { label: "deletedAt", prop: "deletedAt" }
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { label: "操作" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "../Setting/ProjectEdit?parentId=" + scope.row.id
                    }
                  },
                  [_vm._v("添加子项目")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: { href: "../Setting/ProjectEdit?id=" + scope.row.id }
                  },
                  [_vm._v("修改")]
                ),
                _vm._v(" "),
                scope.row.deletedAt
                  ? _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.doUnDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("恢复")]
                    )
                  : _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.doDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("刪除")]
                    )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33279fc4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33279fc4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/setting/ProjectTable.vue
// module id = 699
// module chunks = 75